// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wghi","rootNoMargin":"styles_rootNoMargin__2Hw8U"};